import { put, takeLatest } from '@redux-saga/core/effects'
import { select } from 'redux-saga/effects'
import { singleSelectPageConstants } from '../store/singleSelectPage.constants'
import { getSingleSelectPageSelector } from '../selectors/getSingleSelectPage.selector'
import { ISingleSelectPageState } from '../store/singleSelectPage.types'
import * as actions from '../store/singleSelectPage.actions'
import { ISearchState } from '../../search/store/search.types'
import { getSearchStateSelector } from '../../search/selectors'
import { SearchConstants } from '../../search/store/search.constants'

export function* setChunkedOptions() {
  const singleSelectPageState: ISingleSelectPageState = yield select(getSingleSelectPageSelector)
  const { options, chunkedOptions } = singleSelectPageState
  const searchState: ISearchState = yield select(getSearchStateSelector)
  const { searchText, filteredOptions } = searchState
  if (options && options.length) {
    if (searchText && filteredOptions) {
      const filteredChunk = filteredOptions.slice(chunkedOptions.length, chunkedOptions.length + 20)
      const filteredChunkedOptionsList = [...chunkedOptions, ...filteredChunk]
      yield put(actions.setChunkedOptions(filteredChunkedOptionsList))
    } else {
      const chunk = options.slice(chunkedOptions.length, chunkedOptions.length + 20)
      const chunkedOptionsList = [...chunkedOptions, ...chunk]
      yield put(actions.setChunkedOptions(chunkedOptionsList))
    }
  }
}

export function* setChunkedOptionsSaga() {
  yield takeLatest(
    [
      singleSelectPageConstants.SET_OPTIONS,
      singleSelectPageConstants.UPDATE_CHUNKED_OPTIONS,
      SearchConstants.SET_FILTERED_OPTIONS,
    ],
    setChunkedOptions
  )
}
